module.exports = "img/flags/HT.ad8e6fd.png";